// What a reader can ask about a model, phrased as their own question.
//
// Phrased as the question and not as a description of a capability, because
// clicking one sends it verbatim as the reader's turn.
//
// One list, because these appear in two places: the chat panel's empty state and
// the prompts on the Overview page. Two copies would drift, and the drift would
// be invisible, since nothing renders them side by side.

export const MODEL_QUESTIONS = [
  'What does this model predict?',
  'How does this model perform?',
  'Provide an executive level summary of the model',
];

/**
 * Asked only of a model that has not been deployed, where it is the live
 * question. On a deployed model it is answered by the fact that it is deployed.
 */
export const NOT_LIVE_QUESTION = 'Is this model ready to be deployed?';

/** The questions worth offering for a model in this state. */
export function modelQuestions(live: boolean): string[] {
  return live ? MODEL_QUESTIONS : [...MODEL_QUESTIONS, NOT_LIVE_QUESTION];
}
